import { Flex } from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { componentState } from "../../atoms/componentState";
import { openConfirmTerms } from "../../atoms/openConfirmTerms";
import { BLUEMONEDD, ORANGEMONEDD, WHITE } from "../../constants/colors";
import { dateForAPI } from "../../constants/dataFormat";
import CardSaldo from "./components/cardSaldo";
import CarouselComponent from "./components/dashboardCarousel";
import SalesListDashboard from "./components/SalesListDashboard";
import SalesSimulator from "./components/salesSimulator";
import Simulator from "./components/simulator";
import TablesComponent from "./components/tablesComponent";
import ModalConfirmationTerms from "./defaultComponents/modalConfirmationTerms";
import { useMediaQuery } from "react-responsive";
import { customColors } from "../../atoms/customColors";
import { permissions } from "../../atoms/permissions";

interface Permission {
  idPermissoes: number;
  idCliente: number;
  permissao: string | null;
  cliente: string | null;
}

function Dashboard() {
  const setHeaderLocation = useSetRecoilState(componentState);
  const [isOpen, setIsOpen] = useState(false);
  const dataInicio = moment(Date()).startOf("day").format(dateForAPI);
  const dataFim = moment(Date()).endOf("day").format(dateForAPI);

  const colors = useRecoilValue(customColors);
  const userPermissions = useRecoilValue<Permission[]>(permissions);
  const setOpenTerms = useSetRecoilState(openConfirmTerms);
  const openTerms = useRecoilValue(openConfirmTerms);

  const [dateF, setDateF] = useState(dataFim);
  const [dateI, setDateI] = useState(dataInicio);

  const isMobile = useMediaQuery({ query: "(max-width: 900px)" });

  useEffect(() => {
    setHeaderLocation("Dashboard");
  }, [setHeaderLocation]);

  // Verificação de permissão
  const requiredPermissions = [1, 39];
  const hasPermission = userPermissions.some(
    (permission) => requiredPermissions.includes(permission.idPermissoes)
  );

  // Adicionando logs para depuração
  // console.log("User Permissions:", userPermissions);
  // console.log("Has Permission:", hasPermission);

  return (
    <Flex width="100%" h={"90vh"} overflowY={"scroll"} overflowX={"hidden"}>
      <Flex
        width={"59vw"}
        height={"100%"}
        mt={"0.3%"}
        mx="auto"
        justifyContent={"space-between"}
        alignItems={"center"}
        flexDir={"column"}
      >
        <Flex
          bgColor={colors.BLUEMONEDDBUTTONS}
          w={"90%"}
          h={"12vh"}
          flexDir={"column"}
          alignItems="center"
          justifyContent="center"
          borderRadius={"15px"}
        >
          <CardSaldo />
        </Flex>
        <Flex w={"90%"} h={"27vh"} flexDir={"column"} alignItems="center">
          <TablesComponent
            dateF={dateF}
            setDateF={setDateF}
            dateI={dateI}
            setDateI={setDateI}
          />
        </Flex>
        <Flex
          maxW={"98%"}
          w={"100%"}
          h={"42vh"}
          flexDir={"column"}
          alignItems="center"
        >
          <SalesListDashboard
            dateF={dateF}
            setDateF={setDateF}
            dateI={dateI}
            setDateI={setDateI}
          />
        </Flex>
      </Flex>
      <Flex
        width={"25vw"}
        height={"100vh"}
        mt={"0.3%"}
        mx="auto"
        flexDir={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Flex w={"100%"} h={"55%"} flexDir={"column"} alignItems="center">
          <CarouselComponent />
        </Flex>
        {hasPermission && (
          <Flex
            w={"100%"}
            h={"45%"}
            alignItems={"flex-end"}
            justifyContent={"center"}
            mb={isMobile ? "17vw" : "15vh"}
          >
            <Simulator setIsOpen={setIsOpen} />
          </Flex>
        )}
      </Flex>

      <SalesSimulator isOpen={isOpen} setIsOpen={setIsOpen} />
      <ModalConfirmationTerms isOpen={openTerms} setIsOpen={setOpenTerms} />
    </Flex>
  );
}

export default Dashboard;
